(function () {
  if (window.StrikemanAnalytics) return;

  var script = document.currentScript || document.querySelector('script[data-strikeman-analytics]');

  function referrerHost() {
    if (!document.referrer) return '';

    try {
      return new URL(document.referrer).hostname;
    } catch (error) {
      return '';
    }
  }

  function viewportCategory() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width <= 749) return 'mobile';
    if (width <= 989) return 'tablet';
    return 'desktop';
  }

  function sessionContext() {
    var storageKey = 'strikeman:analytics-session-context';
    var storedContext = null;

    try {
      storedContext = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
    } catch (error) {}

    if (storedContext && storedContext.landingPath) return storedContext;

    var params = new URLSearchParams(window.location.search);
    var newContext = {
      landingPath: window.location.pathname,
      entryReferrerHost: referrerHost(),
      utmSource: params.get('utm_source') || '',
      utmMedium: params.get('utm_medium') || '',
      utmCampaign: params.get('utm_campaign') || '',
    };

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(newContext));
    } catch (error) {}

    return newContext;
  }

  var entryContext = sessionContext();
  var context = {
    eventVersion: 2,
    themeId: script && script.dataset.themeId ? script.dataset.themeId : '',
    themeRole: script && script.dataset.themeRole ? script.dataset.themeRole : '',
    themeLabel: script && script.dataset.themeLabel ? script.dataset.themeLabel : '',
    pageType: script && script.dataset.pageType ? script.dataset.pageType : '',
    currency: script && script.dataset.currency ? script.dataset.currency : '',
    locale: document.documentElement.lang || '',
    landingPath: entryContext.landingPath || '',
    entryReferrerHost: entryContext.entryReferrerHost || '',
    utmSource: entryContext.utmSource || '',
    utmMedium: entryContext.utmMedium || '',
    utmCampaign: entryContext.utmCampaign || '',
  };
  var googleDestination = script && script.dataset.googleDestination ? script.dataset.googleDestination : '';
  var pendingShopifyEvents = [];
  var pendingGoogleEvents = [];
  var flushAttempts = 0;
  var googleFlushAttempts = 0;
  var googleFlushTimer = null;

  function compact(value) {
    if (Array.isArray(value)) return value.map(compact);
    if (!value || typeof value !== 'object') return value;

    return Object.keys(value).reduce(function (result, key) {
      var item = value[key];
      if (item !== undefined && item !== null && item !== '') result[key] = compact(item);
      return result;
    }, {});
  }

  function commonPayload(payload) {
    return compact(
      Object.assign({}, context, payload || {}, {
        path: window.location.pathname,
        viewportCategory: viewportCategory(),
        viewportWidth: window.innerWidth || document.documentElement.clientWidth || 0,
        coarsePointer: window.matchMedia ? window.matchMedia('(pointer: coarse)').matches : false,
        timestamp: new Date().toISOString(),
      })
    );
  }

  function publishToShopify(eventName, payload) {
    var publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
    if (typeof publish !== 'function') return false;

    try {
      var result = publish('strikeman:' + eventName, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  function googleEventValue(value) {
    if (Array.isArray(value) || (value && typeof value === 'object')) {
      try {
        return JSON.stringify(value).slice(0, 100);
      } catch (error) {
        return '';
      }
    }

    return typeof value === 'string' ? value.slice(0, 100) : value;
  }

  function publishToGoogleAnalytics(eventName, payload) {
    if (!googleDestination || typeof window.gtag !== 'function') return false;

    var googlePayload = Object.keys(payload || {}).reduce(
      function (result, key) {
        if (key === 'timestamp') return result;

        var value = googleEventValue(payload[key]);
        if (value !== undefined && value !== null && value !== '') result[key] = value;
        return result;
      },
      {
        event_category: 'strikeman',
        send_to: googleDestination,
      }
    );

    try {
      window.gtag('event', String(eventName).slice(0, 40), googlePayload);
      return true;
    } catch (error) {
      return false;
    }
  }

  function flushShopifyEvents() {
    if (!pendingShopifyEvents.length) return;

    pendingShopifyEvents = pendingShopifyEvents.filter(function (entry) {
      return !publishToShopify(entry.eventName, entry.payload);
    });
    flushAttempts += 1;
    if (pendingShopifyEvents.length && flushAttempts < 12) window.setTimeout(flushShopifyEvents, 500);
  }

  function flushGoogleEvents() {
    googleFlushTimer = null;
    if (!pendingGoogleEvents.length) return;

    pendingGoogleEvents = pendingGoogleEvents.filter(function (entry) {
      return !publishToGoogleAnalytics(entry.eventName, entry.payload);
    });
    googleFlushAttempts += 1;
    if (pendingGoogleEvents.length && googleFlushAttempts < 20) {
      googleFlushTimer = window.setTimeout(flushGoogleEvents, 500);
    }
  }

  function queueGoogleEvent(eventName, payload) {
    if (!pendingGoogleEvents.length) googleFlushAttempts = 0;
    pendingGoogleEvents.push({ eventName: eventName, payload: payload });
    if (!googleFlushTimer) googleFlushTimer = window.setTimeout(flushGoogleEvents, 250);
  }

  function track(eventName, payload, options) {
    if (!eventName) return;

    var settings = options || {};
    if (settings.onceKey) {
      var storageKey = 'strikeman:event:' + settings.onceKey;
      try {
        if (window.sessionStorage.getItem(storageKey)) return;
        window.sessionStorage.setItem(storageKey, '1');
      } catch (error) {}
    }

    var eventPayload = commonPayload(payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: 'strikeman_' + eventName,
          strikemanEvent: eventName,
        },
        eventPayload
      )
    );

    document.dispatchEvent(
      new CustomEvent('strikeman:' + eventName, {
        detail: eventPayload,
      })
    );

    if (!publishToShopify(eventName, eventPayload)) {
      pendingShopifyEvents.push({ eventName: eventName, payload: eventPayload });
      flushShopifyEvents();
    }

    if (!publishToGoogleAnalytics(eventName, eventPayload)) {
      queueGoogleEvent(eventName, eventPayload);
    }
  }

  window.StrikemanAnalytics = {
    context: context,
    track: track,
  };
  document.documentElement.dataset.strikemanAnalytics = 'ready';
  window.addEventListener('load', flushGoogleEvents, { once: true });

  function trackThemeExposure() {
    track(
      'theme_exposure',
      {
        referrerHost: referrerHost(),
      },
      { onceKey: 'theme-exposure:' + (context.themeId || context.themeLabel || 'unknown') }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackThemeExposure, { once: true });
  } else {
    trackThemeExposure();
  }
})();
